'use strict';

/* Values */

var values = {};

values.register = function(name, constant) {
  /* if the app is in loading phase, register the controller in config phase */
  if (app.register == null) {
    app.config(function() {
      app.register.value(name, constant);
    });
  } else {
    /* if the app is allready running just regsiter the new controller */
    app.register.value(name, constant);
  }
  return constant;
};

global.values = values;
